<script setup>
import BaseUserAvatar from '@/components/BaseUserAvatar.vue';
import Helpers from '@/helpers';
import { useAuthStore } from '@/stores/auth.store.js';
import { useUserStore } from '@/stores/user.store.js';
import { computed } from 'vue';

const currentUser = computed(() => useUserStore().currentUser);

function isExternal(url)
{
  return /^https?:\/\//i.test(url);
}
</script>

<template>
  <v-menu :close-on-content-click="!useAuthStore().isLoading" attach="#app">
    <template v-slot:activator="{ props }">
      <BaseUserAvatar style="cursor: pointer" v-bind="props" :user="currentUser" />
    </template>

    <v-card class="nav-menu" min-width="320">
      <div class="tw-flex tw-items-center tw-px-4 tw-py-4">
        <BaseUserAvatar :text-styles="`cursor: pointer;font-size: 1.688rem; width: 80px; line-height: 64px;`" :size="64" :user="currentUser" />
        <div class="tw-ml-3 tw-flex tw-flex-grow tw-flex-col">
          <h4 class="tw-mb-1 tw-font-bold" style="letter-spacing: 0.5px">
            {{ `${currentUser.first_name} ${currentUser.last_name}` }}
          </h4>
          <div class="tw-text-[0.85rem] tw-text-[#5b5b5b]">{{ currentUser.email }}</div>
        </div>
      </div>

      <v-divider></v-divider>

      <v-list :lines="false" density="compact" nav class="tw-px-0">
        <template v-for="(link, i) in Helpers.getHomeNavLinks()" :key="i">
          <!-- External: use href -->
          <v-list-item
            v-if="isExternal(link.to)"
            class="tw-px-4"
            :href="link.to"
            target="_blank"
            rel="noopener"
          >
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>

          <!-- Internal: use router -->
          <v-list-item
            v-else
            class="tw-px-4"
            :to="link.to"
            exact
          >
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item class="tw-mb-3 tw-px-4" @click="useAuthStore().logout">
          <v-progress-circular v-if="useAuthStore().isLoading" width="2" size="24" color="primary" indeterminate></v-progress-circular>
          <v-list-item-title v-else> Logout </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style lang="css" scoped>
.v-list-item-title {
  padding: 5px;
  font-size: 0.9rem !important;
  letter-spacing: 0.5px !important;
}

.v-list .v-list-item--nav:not(:only-child) {
  border-radius: 0px;
}
</style>
